import { useApplyServerReprice } from '@order-up/client/vite';
import type { Cart } from '@order-up/models';

import type { ScheduledCartNotice } from './scheduledCartNotice';

/**
 * What the checkout's "Update my cart" does with a scheduled-menu-pricing
 * refusal: write the SERVER's answer to the cart in one step
 * (`useApplyServerReprice` → `applyServerRepricing` → the Firestore cart), so
 * the preview re-quotes a cart the server accepts. Its own hook so the page's
 * confirm path is exercised end to end by a test, through the cart write.
 */
export function useScheduledNoticeConfirm(handlers: {
  readonly onApplied: () => void;
  readonly onError: (error: unknown) => void;
}) {
  const apply = useApplyServerReprice();
  const confirm = (input: {
    readonly cart: Cart;
    readonly tenantId: number;
    readonly restaurantId: number;
    readonly notice: ScheduledCartNotice;
  }) =>
    apply.mutate(
      {
        cart: input.cart,
        tenantId: input.tenantId,
        restaurantId: input.restaurantId,
        refusals: input.notice.refusals,
      },
      { onSuccess: () => handlers.onApplied(), onError: handlers.onError },
    );
  return { confirm, isApplying: apply.isPending };
}
